import * as React from 'react';
import flatImg from './img/flat.svg';
import newBuildingImg from './img/new-building.svg';

import { ElementInViewport } from '../../../../packages/ElementInViewport';
import { BlockHeader } from '../../components/BlockHeader';
import { LandingBlock } from '../../components/LandingBlock';
import { ContentWrapper } from '../../components/ContentWrapper';

import { trackQuickLinksBlockShow, trackNewbuildingClick, trackOldHousesClick } from './tracking';

import * as style from './styles.css';

export const QuickLinks = () => {
  return (
    <ElementInViewport onVisibleFirst={trackQuickLinksBlockShow}>
      <LandingBlock>
        <ContentWrapper>
          <BlockHeader>Выбирайте жильё на Циан</BlockHeader>
          <div className={style['cards']}>
            <a
              className={style['card']}
              href="/kupit-kvartiru-vtorichka/"
              target="_blank"
              rel="nofollow noopener"
              onClick={trackOldHousesClick}
            >
              <img className={style['img']} src={flatImg} />
              <div className={style['content']}>
                <div className={style['title']}>Вторичное жильё</div>
              </div>
            </a>
            <a
              className={style['card']}
              href="/novostrojki/"
              target="_blank"
              rel="nofollow noopener"
              onClick={trackNewbuildingClick}
            >
              <img className={style['img']} src={newBuildingImg} />
              <div className={style['content']}>
                <div className={style['title']}>Новостройки</div>
              </div>
            </a>
          </div>
        </ContentWrapper>
      </LandingBlock>
    </ElementInViewport>
  );
};
